import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClassModel } from 'src/app/model/class';

@Component({
  selector: 'app-session-details-dialog',
  templateUrl: './session-details-dialog.component.html',
  styleUrls: ['./session-details-dialog.component.css']
})
export class SessionDetailsDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<SessionDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data : ClassModel | any,
  ) { }

  ngOnInit(): void {
    console.log("Session Details: ", this.data)
  }


  closeSessionInfor = () => {
    this.dialogRef.close();
  }

}
